import 'iframe-resizer/js/iframeResizer';

(function() {
  const loaded = function() {
    const currentUrl = new URL(`${document.location}`);
    const lang =
      currentUrl.searchParams.get('locale') ||
      currentUrl.searchParams.get(
        'com.veriday.digitalagent.web.locale.override'
      ) || window['locale'];
    window['locale'] = lang ?
      lang.split('_')[0] :
      window.location.host === 'www1.digitalagent.ca' ? 'en' : 'fr';

    const contactWidgetContainer =
      document.getElementById('contact-widget-container');

    if (contactWidgetContainer) {
      const contactWidgetUrl = new URL(
        window['contactWidgetUrl'] || 'https://widgets.demos-rj.com/contact'
      );

      contactWidgetUrl.searchParams.set(
        'locale', window['locale'].split('_')[0]
      );

      const contactIframeStyle = document.createElement('style');
      contactIframeStyle.innerHTML = `#contact-widget {
width: 1px !important;
min-width: 100% !important;
overflow: hidden !important;
overflow-y: auto !important;
outline: 0 !important;
border: none !important;
}`;
      document.head.append(contactIframeStyle);

      const contactIframe =
        document.createElement('iframe') as HTMLIFrameElement;
      contactIframe.setAttribute('id', 'contact-widget');
      contactIframe.setAttribute('src', contactWidgetUrl.href);
      contactWidgetContainer.innerHTML = '';
      contactWidgetContainer.append(contactIframe);

      setTimeout(
        () => window['iFrameResize']({ log: false }, '#contact-widget')
        , 1000
      );
    }

    // Meet
    const meetWidgetUrl = new URL(
      window['meetWidgetUrl'] || 'https://widgets.demos-rj.com/meet'
    );

    const meetWidgetButtons = document.querySelectorAll(
      `a[href="${meetWidgetUrl.href}"]`
    ) as NodeListOf<HTMLButtonElement>;

    meetWidgetUrl.searchParams.set('locale', window['locale'].split('_')[0]);

    if (meetWidgetButtons.length) {
      meetWidgetButtons.forEach(
        (btn) => btn.setAttribute('href', '#meetWidget')
      );

      const meetIframeStyle = document.createElement('style');
      meetIframeStyle.innerHTML = `#meet-widget {
position: fixed !important;
top: 0 !important;
left: 0 !important;
width: 100% !important;
height: 100% !important;
overflow: hidden !important;
overflow-y: auto !important;
outline: 0 !important;
opacity: 1 !important;
z-index: 3000 !important;
background-color: rgba(0, 0, 0, 0.95) !important;
border: none !important;
}
#meet-widget[aria-hidden="true"] {
transition: opacity 0.5s !important;
opacity: 0 !important;
z-index: -1 !important;
left: -100vw !important;
}
#meet-widget[aria-hidden="false"] {
transition: opacity 0.5s !important;
}`;
      document.head.append(meetIframeStyle);

      const meetIframe =
        document.createElement('iframe') as HTMLIFrameElement;
      meetIframe.setAttribute('id', 'meet-widget');
      meetIframe.setAttribute('aria-hidden', 'true');
      document.body.append(meetIframe);

      const reloadIframe = function(iframe: HTMLIFrameElement, src: string) {
        const iframeContainer = iframe.parentElement;
        iframe.remove();
        iframe.setAttribute('src', src);
        iframeContainer.append(iframe);
      }

      const bodyStyle = document.body.getAttribute('style') || '';
      const toggleIframe = function(iframe: HTMLIFrameElement) {
        const open = location.hash === '#meetWidget';
        iframe.setAttribute('aria-hidden', `${!open}`);
        document.body.setAttribute(
          'style',
          open ? 'overflow: hidden;' + bodyStyle : bodyStyle
        );

        if (open) {
          iframe.scrollTop = 0;
          iframe.contentWindow.focus();
          reloadIframe(iframe, meetWidgetUrl.href);
        } else {
          setTimeout(
            () => reloadIframe(iframe, '')
            , 1000
          );

          if (window['gtag']) {
            window['gtag'](
              'config',
              window['GOOGLE_ANALYTICS_ID'],
              { 'page_path': location.pathname }
            );
          }
        }
      }

      window.addEventListener('message', function(e) {
        try {
          let eventObject =  JSON.parse(e.data);

          switch (eventObject.eventType) {
            case 'meet':
              switch (eventObject.eventName) {
                case 'close':
                  if (location.hash === '#meetWidget') {
                    const historyTotal = eventObject.data.historyTotal;
                    setTimeout(
                      function() { window.history.go(-historyTotal); } 
                    );
                  }
                  break;

                case 'step':

                  break;

                default:
                  break;
              }
              break;

            case 'video':
              const analyticsEvents: string[] = [
                'start', 'pause', 'seek', 'watchedFirstQuarter', 'watchedHalf',
                'watchedThirdQuarter', 'watchedFull'
              ];

              if (
                window['gtag'] && analyticsEvents.includes(eventObject.eventName)
              ) {
                window['gtag'](
                  'event',
                  `video:${eventObject.eventName}`,
                  {
                    'event_category': 'video',
                    'event_label': window.location.pathname
                  }
                );
              }
              break;

            default:
              break;
          }

          if (eventObject.closedEvent && location.hash === '#meetWidget') {
            const historyTotal = eventObject.historyTotal;
            setTimeout(
              function() { window.history.go(-historyTotal); } 
            );
          }
        } catch(error) {
          // console.log(error);
        }
      });

      window.addEventListener('hashchange', function() {
        toggleIframe(meetIframe);
      }, false);
      if (location.hash === '#meetWidget') {
        history.pushState(
          '',
          document.title,
          window.location.pathname + window.location.search
        );
      }
    }
  }

  if (document.readyState !== 'loading') {
    loaded();
  } else {
    document.addEventListener('DOMContentLoaded', loaded);
  }
})();
